/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useRef, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "@mui/material/Table";
import DataTable from "../../examples/Tables/DataTable";
import data from "../dashboard/components/Projects/data";
import useApi from "../../components/Utils/api";
import MDInput from "../../components/MDInput";
import toast from "react-hot-toast";
import subDays from "date-fns/subDays";
import startOfMonth from "date-fns/startOfMonth";
import addMonths from "date-fns/addMonths";
import endOfMonth from "date-fns/endOfMonth";
import { useNavigate } from "react-router-dom";
import Icon from "@mui/material/Icon";
import BulkAssignMerchant from "./bulk-assign";
import Papa from 'papaparse';
// ... (existing imports)
// ... (existing imports)

function MerchantAllTerminals() {
  const { allTerminalTablecolumns } = data();
  const [merchants, setMerchants] = useState([]);
  const [searchMerchantId, setSearchMerchantId] = useState("");
  const api = useApi();

  const handleSearchChange = (event) => {
    setSearchMerchantId(event.target.value);
  };

  const getMerchants = () => {
    const requestData = {
      mid: searchMerchantId,
      msisdn: "",
    };

    api.post("terminal/browse", requestData)
      .then((response) => {
        if (response.data.statusCodeValue === 200) {
          const filteredMerchants = response.data.body.filter(
            (merchant) =>
              merchant.mid === searchMerchantId || searchMerchantId === ""
          );
          setMerchants(filteredMerchants);
        } else {
          toast.error(response.data.error);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        console.log(error.response.data);
      });
  };

  const generateCSV = () => {
    if (merchants.length === 0) {
      return '';
    }

    const headers = allTerminalTablecolumns.map((column) => column.Header);

    const transactionsWithUppercaseColumns = merchants.map((merchant) => {
      return allTerminalTablecolumns.map((column) => {
        const accessor = column.accessor;
        const value =
          typeof accessor === 'function' ? accessor(merchant) : merchant[accessor];
        return value;
      });
    });

    const csvData = [headers, ...transactionsWithUppercaseColumns];

    const csv = Papa.unparse(csvData, {
      quotes: true,
    });

    return csv;
  };

  const handleDownloadCSV = () => {
    if (merchants.length === 0) {
      toast.error("No records found to download.");
      return;
    }

    const csvData = generateCSV();
    const currentDate = new Date().toISOString().slice(0, 10);
    const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
    const dateTimeString = `${currentDate}_${currentTime}`;
    const fileName = `Merchant_Terminals_${dateTimeString}.csv`;

    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    getMerchants();
  }, [searchMerchantId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
          <MDBox mb={3}>
            
             
            </MDBox>
            <MDButton
              variant="gradient"
              onClick={handleDownloadCSV}
              color="info"
              style={{ marginRight: "24px", marginBottom: "12px" }}
            >
              Export
            </MDButton>
            <MDInput
                label="Search by Merchant ID"
                variant="outlined"
                
                value={searchMerchantId}
                onChange={handleSearchChange}
                style={{ background: "white", marginRight: "24px", marginBottom: "12px" }}

              />
            <DataTable
              table={{ columns: allTerminalTablecolumns, rows: merchants }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              canSearch={true}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MerchantAllTerminals;
